import { render, staticRenderFns } from "./CollectionFee.vue?vue&type=template&id=21b0eeb9&"
import script from "./CollectionFee.vue?vue&type=script&lang=js&"
export * from "./CollectionFee.vue?vue&type=script&lang=js&"
import style0 from "./CollectionFee.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports